import { useTranslation } from "react-i18next";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

interface MobileMenuButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

/**
 * 移動端選單按鈕組件
 * 用於切換移動端選單的顯示狀態
 */
export function MobileMenuButton({ isOpen, onClick }: MobileMenuButtonProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className="inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:bg-gray-700 focus:outline-none"
      aria-controls="mobile-menu"
      aria-expanded={isOpen}
      onClick={onClick}
    >
      <span className="sr-only">
        {isOpen ? t("nav.close_menu") : t("nav.open_menu")}
      </span>
      {/* 打開圖標 */}
      <Bars3Icon
        className={`${isOpen ? "hidden" : "block"} h-5 w-5`}
        aria-hidden="true"
      />
      {/* 關閉圖標 */}
      <XMarkIcon
        className={`${isOpen ? "block" : "hidden"} h-5 w-5`}
        aria-hidden="true"
      />
    </button>
  );
}
